module.exports = __webpack_public_path__ + "img/9.bbb82dde.jpg";